<template>
  <WebChapterTemplate
    page-title="新媒体蓝皮书发布暨新媒体发展研讨会"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <div class="bluebook-manual">
      <section class="bluebook-section">
        <div class="bluebook-section__header">
          <h2 class="bluebook-section__title">新媒体蓝皮书发布暨新媒体发展研讨会</h2>
        </div>

        <div class="bluebook-feature">
          <div class="bluebook-feature__gallery">
            <figure class="bluebook-figure bluebook-figure--main">
              <img
                :src="require('./assets/html/bluebook-2014-main.jpg')"
                alt="2014 年《中国新媒体发展报告》发布会现场"
                loading="lazy"
              />
            </figure>
            <figure class="bluebook-figure bluebook-figure--side">
              <img
                :src="require('./assets/html/bluebook-2014-report.jpg')"
                alt="2014 年蓝皮书主编报告主要内容"
                loading="lazy"
              />
            </figure>
          </div>
          <div class="bluebook-feature__text">
            <p>
              2014 年 6 月，新闻与传播研究所与社会科学文献出版社联合主办的《中国新媒体发展报告》（2014）发布暨新媒体发展研讨会在北京举行，院秘书长高翔出席会议并致辞。
            </p>
            <p>
              右图为蓝皮书主编唐绪军在发布会上报告蓝皮书主要内容。
            </p>
          </div>
        </div>

        <div class="bluebook-grid">
          <article class="bluebook-card">
            <figure class="bluebook-figure">
              <img
                :src="require('./assets/html/bluebook-2015.jpg')"
                alt="2015 年《中国新媒体发展报告》发布会现场"
                loading="lazy"
              />
            </figure>
            <div class="bluebook-card__body">
              <h3 class="bluebook-card__title">2015 年《中国新媒体发展报告》发布会</h3>
              <p class="bluebook-card__text">
                2015 年 6 月，新闻与传播研究所与社会科学文献出版社联合主办的《中国新媒体发展报告》（2015）发布暨新媒体发展研讨会在北京举行，副院长李培林出席会议并致辞。
              </p>
            </div>
          </article>

          <article class="bluebook-card">
            <figure class="bluebook-figure">
              <img
                :src="require('./assets/html/bluebook-2016.jpg')"
                alt="2016 年《中国新媒体发展报告》发布会现场"
                loading="lazy"
              />
            </figure>
            <div class="bluebook-card__body">
              <h3 class="bluebook-card__title">2016 年《中国新媒体发展报告》发布会</h3>
              <p class="bluebook-card__text">
                2016 年 6 月，新闻与传播研究所与社会科学文献出版社联合主办的《中国新媒体发展报告》（2016）发布暨新媒体发展研讨会在北京举行，副院长李培林出席会议并致辞。
              </p>
            </div>
          </article>
        </div>
      </section>
    </div>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'Lanhuxinmeitilanpishu',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png')
    };
  }
};
</script>

<style scoped>
.bluebook-manual {
  display: grid;
  gap: 32px;
}

.bluebook-section {
  padding: 26px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.bluebook-section__header {
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.16);
}

.bluebook-section__title {
  margin: 0;
  color: #f25c19;
  font-size: 26px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.bluebook-feature {
  display: grid;
  gap: 20px;
  margin-bottom: 28px;
}

.bluebook-feature__gallery {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(260px, 0.95fr);
  gap: 20px;
}

.bluebook-feature__text {
  display: grid;
  gap: 10px;
  color: #6f3041;
  font-size: 18px;
  line-height: 1.9;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.bluebook-feature__text p {
  margin: 0;
}

.bluebook-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.bluebook-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.16);
  background: #fff;
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
}

.bluebook-figure {
  margin: 0;
  background: #f8f4ee;
}

.bluebook-figure img {
  display: block;
  width: 100%;
  height: auto;
}

.bluebook-card__body {
  padding: 18px 18px 20px;
}

.bluebook-card__title {
  margin: 0 0 8px;
  color: #2f2a25;
  font-size: 20px;
  line-height: 1.5;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
}

.bluebook-card__text {
  margin: 0;
  color: #4c433a;
  font-size: 17px;
  line-height: 1.9;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

@media (max-width: 1024px) {
  .bluebook-feature__gallery,
  .bluebook-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .bluebook-section {
    padding: 18px;
  }

  .bluebook-section__title {
    font-size: 24px;
  }

  .bluebook-feature__text {
    font-size: 16px;
    line-height: 1.8;
  }

  .bluebook-card__title {
    font-size: 18px;
  }

  .bluebook-card__text {
    font-size: 16px;
    line-height: 1.8;
  }
}
</style>
